import React, { useState } from 'react'
import { Button } from 'lib/ui/components'
import { useCart } from 'lib/core/hooks/useCart'
import { useIntl } from 'react-intl'
import { LoginForm } from 'app/sofia/components/LoginForm'
import { CreateAccount } from 'app/sofia/scenes/Customer/scenes/Account/scenes/Create' // TODO: Refactor.
import { useCartTotals } from 'hooks/cart'
import { ShippingForm } from '../Form'
import { EmailForm } from 'lib/modules/checkout'
import { captureEmail } from 'modules/listrak'

interface Props {
  setFirstContentClass: any
}

export const ShippingGuestMain: React.FC<Props> = ({ setFirstContentClass }) => {
  const intl = useIntl()
  const { cart } = useCart()
  const cartItems = cart?.data?.items ?? []
  const [accountState, setAccountState] = useState('main')

  const { subscriptionItemsInCart } = useCartTotals(cartItems)

  const handleLogin = () => {
    setAccountState('login')
  }

  const handleCreateAccount = () => {
    setAccountState('create')
  }

  const handleCheckoutAsGuest = () => {
    setAccountState('checkout')
  }

  switch (accountState) {
    case 'login':
      setFirstContentClass('full-content', 'checkout.account.login')
      return <LoginForm shouldRedirectToAccount={false} avoidRedirect setCheckoutState={setAccountState} />
    case 'create':
      setFirstContentClass('full-content', 'checkout.account.create')
      return <CreateAccount avoidRedirect />
    case 'checkout':
      setFirstContentClass('full-content', 'checkout.header.shipping')
      return (
        <>
          <EmailForm
            interceptBlur={(e) => {
              captureEmail(e.value)
            }}
          />
          <ShippingForm />
        </>
      )
  }

  return (
    <>
      <div className='accountLogin'>
        <h3>{intl.formatMessage({ id: 'checkout.shipping.already.account' })}</h3>
        <Button
          className='outlined'
          skin={Button.SKIN.OUTLINE}
          onClick={handleLogin}
        >
          Login
        </Button>
      </div>
      <div className='newCustomer'>
        <h3>{intl.formatMessage({ id: 'checkout.shipping.new.customers.title' })}</h3>
        <p>{intl.formatMessage({ id: 'checkout.shipping.new.customers.text' })}</p>
        <Button key='button' onClick={handleCreateAccount}>{intl.formatMessage({ id: 'checkout.shipping.new.customers.button' })}</Button>
        {subscriptionItemsInCart?.length < 1 && (
          <div className='linkWrapper'>
            <button className='guest-checkout' onClick={handleCheckoutAsGuest}>
              {intl.formatMessage({ id: 'checkout.shipping.checkout.as.guest' })}
            </button>
          </div>
        )}
      </div>
    </>
  )
}
